var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item flex"},[_c('div',{staticClass:"item__name"},[_vm._v(" "+_vm._s(_vm.$t(_vm.$options.dysfunctionNameBinding[_vm.skinItem.name]))+" ")]),_c('span',{staticClass:"item__value"},[_vm._v(" "+_vm._s(_vm.$t(`dashboard.medicalData.${_vm.skinItem.value}`))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }